class EnquiryController {
  constructor() {
    this.name = 'enquiry';
  }
}

export default EnquiryController;



// WEBPACK FOOTER //
// ./client/app/components/enquiry/enquiry.controller.js